export default {
    "Team.index.069632-0": "Our team",
    "Team.index.069632-1": "Zongheng Sihai boasts the most professional maintenance team in the industry, conducting regular training for maintenance service personnel and implementing a strict four-tier training system to ensure the service quality of our maintenance staff.",
    "Team.index.069632-2": "Sara Doe",
    "Team.index.069632-3": "Product Designer",
    "Team.index.069632-4": "Sara is the product designer behind XYZ. On Twitter",
    "Team.index.069632-5": "Follow her up.",
    "Team.index.069632-6": "Nick Doe",
    "Team.index.069632-7": "Full stack developers",
    "Team.index.069632-8": "Nick is a full stack developer specializing in building XYZ. in",
    "Team.index.069632-9": "Follow him online to get the latest development tips and learn from him",
    "Team.index.069632-10": "View useful open-source tools online",
    "Team.index.571669-0": "Sara is behind XYZ",
    "Team.index.571669-1": "On Twitter",
    "Team.index.571669-2": "Nick is a",
    "Team.index.571669-3": "Specializes in building XYZ. in"
}